import { Box } from '@mui/material';
import type { Order } from '../../../api/order';
import OrderHistoryTimeline from './OrderHistoryTimeline';
import OrderItemsCard from './OrderItemsCard';
import type { OrderUpdatedHandler } from './useOrderDetailHandlers';

interface OrderDetailViewProps {
  order: Order;
  selectedItemId?: number | null;
  onUpdated: OrderUpdatedHandler;
  historyRefreshKey: number;
}

const OrderDetailView = ({
  order,
  selectedItemId,
  onUpdated,
  historyRefreshKey,
}: OrderDetailViewProps) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
    <OrderItemsCard
      order={order}
      selectedItemId={selectedItemId}
      onUpdated={onUpdated}
    />
    <OrderHistoryTimeline order={order} refreshKey={historyRefreshKey} />
  </Box>
);

export default OrderDetailView;
